export { CUSTOM_IMAGE_TYPE, registerImageUploadQuestion } from './ImageQuestionCreator';
export { CUSTOM_VIDEO_TYPE, registerVideoUploadQuestion } from './VideoQuestionCreator';
export { CUSTOM_VIEW_MEDIA_TYPE, registerViewMediaQuestion } from './ViewMediaQuestion';
export { CameraIcon, VideoIcon } from './customIcons';
export { UploadMediaComponent } from './UploadMediaComponent';
export { UploadMediaQuizQuestion, QuizQuestionMediaUploader } from './UploadMediaQuestionClasses';
